import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {BeachDashboardComponent} from './dashboard/dashboard.component';
import {BeachSamplesComponent} from './samples/beach-samples.component';
import {BeachResultsComponent} from './results/beach-results.component';
import {BeachOrganizationComponent} from './organization/beach-organization.component';
import {BeachAdvisoriesComponent} from './advisories/beach-advisories.component';
import {BeachStatusComponent} from './status/beach-status.component';
import {BeachReportsComponent} from './reports/beach-reports.component';
import {BeachSubmissionsListComponent} from './submission-list/submission-list.component';
import {SubmissionDetailComponent} from './submission-detail/submission-detail.component';

const routes: Routes = [
  {path: 'dashboard', component: BeachDashboardComponent},
  {path: 'sampling', component: BeachSamplesComponent},
  {path: 'results', component: BeachResultsComponent},
  {path: 'organization', component: BeachOrganizationComponent},
  {path: 'advisory', component: BeachAdvisoriesComponent},
  {path: 'status', component: BeachStatusComponent},
  {path: 'submission/list', component: BeachSubmissionsListComponent},
  {path: 'submission/:id', component: SubmissionDetailComponent},
  {path: 'reports', component: BeachReportsComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BeachesRoutingModule { }
